export default "__VITE_ASSET__BFsVisqZ__"